export function handleStatusText(status) {
    if (
      status === 'AGUARDANDO ANÁLISE DO FINANCEIRO'
    ) {
      return 'PEDIDO RECEBIDO AGUARDANDO ANÁLISE';
    } else if (status === 'EM ANÁLISE PELO FINANCEIRO'){
      return 'EM ANÁLISE PELO FINANCEIRO';
    }else if (
      status ===
        'AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO' ||
      status ===
        'AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO'
    ) {
      return 'AGUARDANDO APROVAÇÃO DA LOGÍSTICA';
    } else if (status === 'LIBERADO') {
      return 'PEDIDO LIBERADO PELO FINANCEIRO';
    } else if (status === 'NÃO LIBERADO PELO FINANCEIRO') {
      return 'PEDIDO COM RESTRIÇÃO';
    } else {
      return 'PEDIDO CANCELADO';
    }
  }
